import React, { useEffect, useRef } from 'react';
import styles from './chat-view.module.css';
import SendIcon from '../../images/send-icon.svg';
import { formatChatTimestamp } from '../../helpers/date-helper';


const ChatView = (props) => {
  const prevCountRef = useRef<number | undefined>(undefined);

  const messages = props.messages.map(message => {
    const { messageId, text, employeeId, employeeName, responsibleName, createdAt } = message;
    
    // Determine if this is the current user's message
    const isOwnMessage = props.currentUserEmployeeId && employeeId === props.currentUserEmployeeId;
    
    // Use consistent logic for styling
    const messageClassname = isOwnMessage ? styles.messageAuthor : styles.messageNonAuthor;
    const wrapperClass = isOwnMessage ? styles.messageWrapperAuthor : styles.messageWrapperNonAuthor;
    
    // Get author name - only show for other users' messages
    let authorName = '';
    if (!isOwnMessage) {
      if (employeeName) {
        authorName = employeeName;
      } else if (responsibleName) {
        authorName = responsibleName;
      }
    }
    
    const timestamp = formatChatTimestamp(createdAt);
    
    return (
      <div className={`${styles.messageWrapper} ${wrapperClass}`} key={messageId}>
        <div className={`${styles.message} ${messageClassname}`}>
          <p className={styles.messageText}>{text}</p>
        </div>
        <div className={styles.messageFooter}>
          {authorName && <span className={styles.authorName}>{authorName}, </span>}
          <span className={styles.timestamp}>{timestamp}</span>
        </div>
      </div>
    );
  });

  const sendMessage = () => {
    const element = document.getElementById('messageBox') as HTMLInputElement;
    const message = element.value;
    props.sendMessage(message);
    element.value = '';
  }

  const onKeyUp = (event) => {
    if (event.key === "Enter") {
      sendMessage();
    }
  }

  const chatContainer = useRef(null);

  useEffect(() => {
    const currentLength = props.messages.length;
    const isInitialLoad = prevCountRef.current === 0 && currentLength > 0;
    const [lastMessage] = props.messages.slice(-1);

    if (lastMessage) {
      const scrollHeight = chatContainer.current.scrollHeight;
      const scrollPosition = scrollHeight - (chatContainer.current.scrollTop + chatContainer.current.offsetHeight);
      const minimumToScroll = scrollHeight * 0.10;

      if (scrollPosition < minimumToScroll || isInitialLoad) {
        chatContainer.current.scrollTo(0, scrollHeight);
      }
    }
    prevCountRef.current = currentLength;
  }, [props.messages]);

  return (
    <div className={styles.rootContainer}>
      <div className={styles.chatContainer}>
        <div id="chatContainer" ref={chatContainer} className={styles.messageContainer}>
          {messages}
        </div>
        <div className={styles.inputContainer}>
          <input type='text' id='messageBox' placeholder='Mensagem' onKeyUp={onKeyUp} className={styles.inputField} />
          <button onClick={sendMessage} className={styles.sendButton}>
            <img src={SendIcon} alt={'Enviar'} title={'Enviar'} className={styles.sendButtonIcon}></img>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatView;
